import axios from "axios";
import React from "react";
import { Api_Url } from "../../config/config";
import { FaUpload } from "react-icons/fa6";
import { MdCancel, MdDelete } from "react-icons/md";
import { Modal } from "antd";

const PdReference = ({ profileId, ProfileId }) => {
  const [expenseData, setExpenseData] = React.useState([]);
  const [relationData, setRelationData] = React.useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  
  const [formExpenseData, setFormExpenseData] = React.useState({
    latitude: "", longitude: "", businessPdProfileId: profileId, name: "", mobile: "", relationId: 0
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    fetchCurentLocation();

    const { data } = await axios.post(Api_Url + "api/v1/ContactReference", formExpenseData, {
      headers: {
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
      }
    });

    if (data.succeeded) {
      fetchExpenseData();
      setIsModalOpen(false);
      setFormExpenseData(prev => ({
        ...prev,
        latitude: "", longitude: "", businessPdProfileId: profileId, name: "", mobile: "", relationId: 0
      }))
    }
  };

  const fetchExpenseData = async () => {
    const { data } = await axios.get(Api_Url + `api/v1/ContactReference/getbybusinesspdprofileid/${profileId}`, {
      headers: {
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
      }
    });
    setExpenseData(data.data)
  };

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setFormExpenseData(prev => ({ ...prev, latitude: latitude.toString(), longitude: longitude.toString() }))
      });
    } else {
      return "Geolocation is not supported by this browser."
    }
  };

  const fetchRelationData = async () => {
    try {
      const { data } = await axios.get(Api_Url + "api/v1/Relation?PageNumber=1&PageSize=50", {
        headers: {
          Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
        }
      });
      setRelationData(data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    fetchExpenseData();
    fetchCurentLocation();
    fetchRelationData()
  }, []);

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-end">
          <button className="btn btn-primary submit-btn" onClick={() => setIsModalOpen(true)}>Add Reference</button>
        </div>
      </div>

      <div className="row mt-4">
        {expenseData.length > 0 && expenseData.map(item => (
          <div className="col-lg-4 col-md-6 col-sm-12 col-12">
            <div className="card py-4 px-3">
              <div className="d-flex align-items-center gap-1">
                <h6 className="">Name: </h6>
                <p>{item?.name}</p>
              </div>
              <div className="d-flex align-items-center gap-1">
                <h6 className="">Mobile Number: </h6>
                <p>{item?.moile}</p>
              </div>
              <div className="d-flex align-items-center gap-1">
                <h6 className="">Created By: </h6>
                <p>{new Date(item?.createdDate).toLocaleDateString()}{"   "}{new Date(item?.createdDate).toLocaleTimeString()}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Add Contact Reference Data */}
      <Modal
        title={<h4>Add Contact Reference</h4>}
        open={isModalOpen}
        centered
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Name
                  </label>
                  <input className="form-control" type="text" placeholder="Name" value={formExpenseData.name} onChange={event => setFormExpenseData({ ...formExpenseData, name: event.target.value })} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Mobile Number
                  </label>
                  <input className="form-control" type="number" placeholder="Mobile Number" value={formExpenseData.mobile} onChange={event => setFormExpenseData({ ...formExpenseData, mobile: event.target.value })} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Select Relation
                  </label>
                  <select className="custom-select-style" value={formExpenseData.relationId} onChange={event => setFormExpenseData({ ...formExpenseData, relationId: event.target.value })}>
                    <option value={0} selected>Select Relation</option>
                    {relationData.length > 0 && relationData.map(vehicle => <option value={vehicle.id}>{vehicle.name}</option>)}
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div >
  )
}

export default PdReference